// @TODO <HEALTH2019>
App.factory('zochaHealthInsuranceService', ['$q', 'baseService', 'Config' ,'healthInsuranceSharedService', function($q, baseService, Config, healthInsuranceSharedService) {
    function ZochaHealthInsuranceService() {
        this.add = function(data) {
            data = healthInsuranceSharedService.convertToHealth(data);
            return baseService.post(Config.API_URL + '/zocha/healthInsuranceDeclaration/save', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };
        this.dataList = function(data) {
            return baseService.post(Config.API_URL + '/zocha/healthInsuranceDeclaration/list', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            }).then(function (data) {
                if (data.status === 200) {
                    var activities = [];
                    data.data.data.forEach(function (single) {
                        activities.push(healthInsuranceSharedService.convertFromHealth(single));
                    });

                    data.data.data = activities;
                }

                return data;
            });
        };

        this.withdraw = function(criteria) {
            return baseService.post(Config.API_URL + '/zocha/healthInsuranceDeclaration/' + criteria.id + '/withdraw', criteria.data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.notify = function(criteria) {
            return baseService.post(Config.API_URL + '/zocha/healthInsuranceDeclaration/' + criteria.id + '/notify', criteria.data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.getDeclaration = function(uuid) {
            return baseService.download(Config.API_URL + '/zocha/healthInsuranceDeclaration/' + uuid + '/declaration').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.getStatement = function(uuid) {
            return baseService.download(Config.API_URL + '/zocha/healthInsuranceDeclaration/' + uuid + '/statement').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.enterOriginalCopyBarcode = function(id) {
            return baseService.get(Config.API_URL + '/zocha/healthInsuranceDeclaration/enterOriginalCopyBarcode/' + id).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };


        this.dataTransferList = function(data) {
            return baseService.post(Config.API_URL + '/zocha/healthInsuranceTransfer/list', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.sendTransfer = function(data) {
            return baseService.post(Config.API_URL + '/zocha/healthInsuranceTransfer/sendTransfer', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };
    }
    return new ZochaHealthInsuranceService();
}]);
// @TODO </HEALTH2019>
